export default class SearchTransferInput {
    fromRegionId: string
  toRegionId: string
  departureDate: string
  adultCount: number
  childCount: number
  infantCount: number
  currencyId: string
  hour:string

}